import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Lottie from "react-lottie";
import { AccordionContext } from "./AccordionContainer";
import Table from "./Table";
import { accordionConfigData as defaultAccordionState } from "../constants";
import {
  RowContainer,
  ChecksPassedParagraph,
  FileNameParagraphNonFileName,
  LottieAnimationContainer,
  DeleteFileButton,
  LaunchScriptButton,
  defaultOptions,
} from "./SuccessContainer";
import { exportToExcel } from "../fileHandlers/ErrorsToExcelDownLoad";
import failAnimation from "../assets/fail_animation.json";

const LottieFailAnimationContainer = styled(LottieAnimationContainer)`
  height: 50px;
  width: 50px;
  margin-top: 0px;
`;
const DownLoadFileErrorsButton = styled(LaunchScriptButton)``;

const styleSheet = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "auto",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    padding: "5px",
    backgroundColor: "",
  },
  checksPassedMessageRowContainer: {
    marginTop: "0px",
  },
  tableRowContainer: {
    width: "90%",
    marginBottom: "25px",
  },
};

const failAnimationDefaultOptions = {
  ...defaultOptions,
  animationData: failAnimation,
};

export default function FailContainer({ file, id }) {
  const { accordionData, setAccordionData } = useContext(AccordionContext);
  const [isPlaying, setIsPlaying] = useState(false);
  useEffect(() => {
    setIsPlaying(true);
  }, []);
  const jsonData = accordionData[id - 1].errorDetails;
  const testSuiteType =
    accordionData[id - 1].fileTestResponse.testSuiteResults.testSuiteResult
      .testSuiteType;
  const defaultFileState = defaultAccordionState[id - 1];

  //reset file to null (delete file and enable to return to file upload state)
  const deleteFile = () => {
    const updatedAccordionData = [...accordionData];
    updatedAccordionData[id - 1] = { ...defaultFileState };
    setAccordionData(updatedAccordionData);
  };

  // assuming jsonData is an array of objects
  const columns = React.useMemo(
    () =>
      Object.keys(jsonData[0]).map((key) => {
        return {
          Header: key,
          accessor: key, // accessor is the "key" in the data
        };
      }),
    [jsonData]
  );

  return (
    <div style={styleSheet.container}>
      <RowContainer>
        <LottieFailAnimationContainer>
          <Lottie options={failAnimationDefaultOptions} isPaused={!isPlaying} />
        </LottieFailAnimationContainer>
      </RowContainer>
      <RowContainer>
        <ChecksPassedParagraph>{`${testSuiteType} Fail`}</ChecksPassedParagraph>
      </RowContainer>
      <RowContainer>
        <FileNameParagraphNonFileName>
          Looks like you failed some tests. don&apos;t worry, you can check your
          errors on the table and reupload your file.
        </FileNameParagraphNonFileName>
      </RowContainer>
      <RowContainer style={styleSheet.tableRowContainer}>
        <Table columns={columns} data={jsonData} />
      </RowContainer>
      <RowContainer>
        <DownLoadFileErrorsButton
          onClick={() => exportToExcel(jsonData, file.name)}
        >
          Download Errors File
        </DownLoadFileErrorsButton>
        <DeleteFileButton onClick={() => deleteFile()}>
          Delete File
        </DeleteFileButton>
      </RowContainer>
    </div>
  );
}

FailContainer.propTypes = {
  id: PropTypes.number.isRequired,
  file: PropTypes.oneOfType([
    PropTypes.shape({
      lastModified: PropTypes.number,
      name: PropTypes.string,
      size: PropTypes.number,
      type: PropTypes.string,
    }),
    PropTypes.instanceOf(null),
  ]),
};
